import { useMutation } from '@tanstack/react-query';
import { ApiClient, apiPaths, useApiErrorStoreActions } from '@repo/api/client';
import { agreementAddSuccessResponseBodySchema } from './agreement-add.schema';
var apiEndpoint = apiPaths.agreement.add;
function postAgreementAdd(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'POST', body: JSON.stringify(payload) },
        successSchema: agreementAddSuccessResponseBodySchema,
    });
}
export function usePostAgreementAdd() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: postAgreementAdd,
        onError: function (error) {
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
